// src/pages/OAuthSuccess.js
// Backend redirects here after Google OAuth with ?token=... so we can route by eligibility:
// if visaEligibilityAnswers or visaEligibilityResponses exist in localStorage → /answer-review, else → /dashboard.

import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { setSignedIn } from "../utils/authStorage";
import { getUserProfile } from "../API/profileAPI";
import { consumePostLoginRedirect } from "../utils/postLoginRedirect";

const OAuthSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // useEffect(() => {
  //   const params = new URLSearchParams(location.search);
  //   const token = params.get("token");

  //   if (token) {
  //     localStorage.setItem("token", token);
  // 
   
  //     const eligibilityData = localStorage.getItem("visaEligibilityAnswers");
  //     if (eligibilityData) {
  //       setTimeout(() => navigate("/answer-review"), 0);
  //     } else {
  //       setTimeout(() => navigate("/dashboard"), 0);
  //     }
  //   } else {
  //     navigate("/");
  //   }
  // }, [location, navigate]);


//   useEffect(() => {
//   const params = new URLSearchParams(location.search);
//   const token = params.get("token");

//   if (token) {
//     localStorage.setItem("token", token);
//     localStorage.setItem("isLoggedIn", "true");

//     const eligibilityData = localStorage.getItem("visaEligibilityAnswers");
//     let hasEligibility = false;

//     try {
//       const parsed = JSON.parse(eligibilityData || "{}");
//       hasEligibility = Object.keys(parsed).length > 0;
//     } catch {
//       hasEligibility = false;
//     }

//     if (hasEligibility) {
//       navigate("/answer-review");   
//     } else {
//       navigate("/dashboard");
//     }
//   } else {
//     navigate("/");
//   }
// }, [location, navigate]);

useEffect(() => {
  const params = new URLSearchParams(location.search);
  // The backend signals a completed sign-in with ?signedIn=1 and sets the
  // session cookie itself. The legacy ?token= form is still accepted so this
  // keeps working against a backend that has not shipped that change yet;
  // the token is read only as a presence flag and is never stored.
  //
  // An earlier version of this comment claimed the callback already set the
  // cookie. It did not — the user-facing Google callback was never part of
  // the task 149 cookie migration, so Google sign-in left no session at all.
  const signedIn = params.get("signedIn") === "1" || Boolean(params.get("token"));

  if (signedIn) {
    setSignedIn();

    const goNext = async () => {
      try {
        const res = await getUserProfile();
        const user = res?.data?.data;
        if (user) {
          localStorage.setItem("userDetails", JSON.stringify(user));
          localStorage.setItem("email", user.email ?? "");
        }
      } catch {
        // Continue; token is stored
      }
      const eligibilityData = localStorage.getItem("visaEligibilityAnswers");
      const responses = localStorage.getItem("visaEligibilityResponses");
      let hasEligibility = false;
      try {
        const parsed = JSON.parse(eligibilityData || "{}");
        hasEligibility = Object.keys(parsed).length > 0;
      } catch {}
      if (!hasEligibility && responses) {
        try {
          const parsedResponses = JSON.parse(responses || "{}");
          hasEligibility = Object.keys(parsedResponses).length > 0;
        } catch {}
      }
      const deepLink = consumePostLoginRedirect();
      if (deepLink) {
        navigate(deepLink);
      } else if (hasEligibility) {
        navigate("/answer-review");
      } else {
        navigate("/dashboard");
      }
    };
    goNext();
  } else {
    navigate("/");
  }
}, [location, navigate]);


  return (
    <div className="flex justify-center items-center min-h-screen">
      <p className="text-lg font-semibold">Logging you in via Google...</p>
    </div>
  );
};

export default OAuthSuccess;
